const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
};

const Utils = {};

Utils.openOverlay = () => {
  document.querySelector(".overlay")?.classList.add("show");
  document.querySelector("body")?.classList.add("modal-open");
};

Utils.closeOverlay = () => {
  document.querySelector(".overlay")?.classList.remove("show");
  document.querySelector("body")?.classList.remove("modal-open");
};

class SeeMySize extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const template = document.getElementById("see-my-size-template");
    const templateInstance = template.cloneNode(true);
    const templateContent = templateInstance.content;
    window.defaultScrollEffect = false;

    const seeMySizeData = JSON.parse(this.dataset.seeMySizeData.trim());
    const modelImagesList = templateContent.querySelector(".model-images .swiper-wrapper");
    const modelStep1ImagesList = templateContent.querySelector(".model-size-step-images .swiper-wrapper");
    const modelSwatchImagesList = templateContent.querySelector(".image-swatches");
    const sizesRange = templateContent.querySelector('.sizes-range');
    const descriptionWrapper =
      templateContent.querySelector(".model-description");
    // Size swatches
    const swatchesWrapper = templateContent.querySelector(".swatches-wrapper");
    let container = document.querySelector("[data-selected-product-size]");
    let currentSize = this.dataset.selectedSize || 'S';
    if (container) {
      currentSize = container.getAttribute('data-selected-product-size').trim() || 'S';
    }
    let isSizeAvailableInData = seeMySizeData.find((size) => size.id.toLowerCase() === currentSize.toLowerCase());
    if (!isSizeAvailableInData) {
      currentSize = 'S';
    }
    const selectedSize = currentSize;
    seeMySizeData.forEach((size) => {
      const listItem = document.createElement("li");
      const swatchBtn = document.createElement("button");
      swatchBtn.classList.add('size-selection-btn')
      if (size.id.toUpperCase() === selectedSize.toUpperCase()) {
        swatchBtn.classList.add("selected");
      }
      swatchBtn.innerText = size.id.toUpperCase();
      swatchBtn.dataset.id = size.id.toUpperCase();

      let firstSizeImage = size.images[0];
      let firstSizeDesc = size.description;
      let swatchImageItem = document.createElement("li");
      swatchImageItem.classList.add('size-first-image-container')
      swatchImageItem.setAttribute('id', `list_size_image_${firstSizeImage?.id}`)
      swatchImageItem.classList.add('swiper-slide')
      swatchImageItem.setAttribute('size-name', size.id)
      const modelSwatchImage = document.createElement("img");
        modelSwatchImage.setAttribute('loading', 'lazy')
        modelSwatchImage.src = `${firstSizeImage?.src}&width=300`;
      modelSwatchImage.alt = firstSizeDesc;
      modelSwatchImage.classList.add('cursor-pointer');
      swatchImageItem.append(modelSwatchImage);
      modelStep1ImagesList.append(swatchImageItem);

      swatchBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        const matchedSize = seeMySizeData.find(
          (sizeInstance) => sizeInstance.id === size.id
        );
        swatchImageItem.querySelectorAll("button").forEach((btn) => {
          btn.classList.remove("selected");
        });
        swatchImageItem
          .querySelector(`button[data-id="${matchedSize.id}"]`)
          .classList.add("selected");
        modelImagesList.scrollLeft = 0;
        modelImagesList.innerHTML = "";
        modelSwatchImagesList.innerHTML = "";
        let counter = 0;
        matchedSize.images.map((image, i) => {
          counter++;
          const listItem = document.createElement("li");
          listItem.setAttribute('id', `list_image_${image.id}`)
          listItem.classList.add('swiper-slide')
          const modelImage = document.createElement("img");
          modelImage.src = `${image.src}&width=800`;
          descriptionWrapper.innerHTML = image.description;
          modelImage.alt = descriptionWrapper.innerHTML;
          if (i == 0) {
            const clickMeButton2 = document.createElement("button");
            clickMeButton2.classList.add("click-me-btn");
            console.log(image)
            const sizeSpan2 = document.createElement("span");
            sizeSpan2.classList.add("size-text");
            sizeSpan2.innerText = size.id.toUpperCase();

            const descSpan2 = document.createElement("span");
            descSpan2.classList.add("desc-text");
            descSpan2.innerText = matchedSize.description;
            clickMeButton2.append(sizeSpan2, descSpan2);
            listItem.append(modelImage, clickMeButton2);
          } else {
            listItem.append(modelImage);
          }

          modelImagesList.append(listItem);
          const swatchListItem = document.createElement("div");
          swatchListItem.classList.add('image-swatch')
          swatchListItem.setAttribute('id', `swatch_image_${image.id}`)
          if (counter === 1) {
            swatchListItem.classList.add('active');
          }
          swatchListItem.addEventListener('click', function () {
            window.defaultScrollEffect = true;
            modelSwatchImagesList.querySelector('.image-swatch.active')?.classList.remove('active')
            swatchListItem.classList.add('active')
            listItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
            setTimeout(() => {
              window.defaultScrollEffect = false;
            }, 500)
          });
          const modelSwatchImage = document.createElement("img");
          modelSwatchImage.src = `${image.src}&width=100`;
          modelSwatchImage.alt = descriptionWrapper.innerHTML;
          swatchListItem.append(modelSwatchImage);
          modelSwatchImagesList.append(swatchListItem);
        });
        this.querySelector('[data-see-size-step-1]')?.classList?.add('d-none');
        this.querySelector('[data-see-size-step-2]')?.classList?.remove('d-none');
        this.querySelector('[data-see-size-mini-swatch]')?.classList?.remove('d-none');
        this.querySelector('[data-see-size-mini-swatch]')?.classList?.add('d-flex');
        this.querySelector('[data-see-size-back]')?.classList?.remove('d-none');
      });
      swatchImageItem.append(swatchBtn);
      swatchImageItem.addEventListener('click', () => {
        swatchBtn.click();
      })
    });
    // Model gallery
    let matchedSize = seeMySizeData.find(
      (size) => size.id.toLowerCase() === selectedSize.toLowerCase()
    );

    // Sizes range
    if (matchedSize) {
      sizesRange.innerText = `${seeMySizeData[0].id.toUpperCase()} - ${seeMySizeData[seeMySizeData.length - 1].id.toUpperCase()}`;

      // Description
      descriptionWrapper.innerText = matchedSize.description;
      let count = 0;
      matchedSize.images.map((image) => {
        count++;
        const listItem = document.createElement("li");
        listItem.setAttribute('id', `list_image_${image.id}`)
        listItem.classList.add('swiper-slide')
        const modelImage = document.createElement("img");
        modelImage.src = `${image.src}&width=800`;
        modelImage.alt = image.description;
        modelImage.setAttribute("loading", "lazy");

        // button created
        const clickMeButton = document.createElement("button");
        clickMeButton.classList.add("click-me-btn");

        const sizeSpan = document.createElement("span");
        sizeSpan.classList.add("size-text");
        sizeSpan.innerText = "XS";

        const descSpan = document.createElement("span");
        descSpan.classList.add("desc-text");
        descSpan.innerText = matchedSize.description;

        clickMeButton.append(sizeSpan, descSpan);
        listItem.append(modelImage, clickMeButton);
        modelImagesList.append(listItem);
        const swatchListItem = document.createElement("div");
        swatchListItem.classList.add('image-swatch')
        if (count === 1) {
          swatchListItem.classList.add('active');
        }
        swatchListItem.setAttribute('id', `swatch_image_${image.id}`)
        swatchListItem.addEventListener('click', function () {
          window.defaultScrollEffect = true;
          modelSwatchImagesList.querySelector('.image-swatch.active')?.classList.remove('active')
          swatchListItem.classList.add('active')
          listItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
          setTimeout(() => {
            window.defaultScrollEffect = false;
          }, 500)
        });
        const modelSwatchImage = document.createElement("img");
        modelSwatchImage.src = `${image.src}&width=100`;
        modelSwatchImage.alt = descriptionWrapper.innerHTML;
        modelSwatchImage.setAttribute("loading", "lazy");
        swatchListItem.append(modelSwatchImage);
        modelSwatchImagesList.append(swatchListItem);
      });

      modelImagesList.addEventListener('scroll', () => {
        modelImagesList.querySelectorAll('li').forEach((modelImageEl, modelImageIndex) => {
          let rect = modelImageEl.getBoundingClientRect();
          let inViewPort = (rect.left >= 0 && rect.left <= 120) ||
            (rect.right <= (window.innerWidth || document.documentElement.clientWidth) + 120);

          if (inViewPort && !window.defaultScrollEffect) {
            let scrollImageId = modelImageEl.getAttribute('id');
            scrollImageId = scrollImageId.replace('list_image_', 'swatch_image_');
            modelSwatchImagesList.querySelector('.image-swatch.active')?.classList.remove('active')
            modelSwatchImagesList.querySelector(`#${scrollImageId}`)?.classList.add('active')
          }
        })
      })

      // Close modal button
      const closeBtn = templateContent.querySelector(".close-btn");
      closeBtn.addEventListener("click", () => {
        this.remove();
        document.querySelector('body').classList.remove('position-fixed-mobile');
        document.body.style.overflowY = "auto";
        Utils.closeOverlay();
      });

      const closeOverlay = document.querySelector(".overlay");
      closeOverlay?.addEventListener("click", () => {
        this.remove();
        document.querySelector('body').classList.remove('position-fixed-mobile');
        document.body.style.overflowY = "auto";
        Utils.closeOverlay();
      });

      this.appendChild(templateContent);
    }

    this.querySelector('[data-see-size-back]')?.addEventListener('click', (e) => {
      this.querySelector('[data-see-size-step-1]')?.classList?.remove('d-none');
      this.querySelector('[data-see-size-step-2]')?.classList?.add('d-none');
      this.querySelector('[data-see-size-mini-swatch]')?.classList?.add('d-none');
      this.querySelector('[data-see-size-mini-swatch]')?.classList?.remove('d-flex');
      this.querySelector('[data-see-size-back]')?.classList?.add('d-none');
    })
  }
}

customElements.define("see-my-size", SeeMySize);

document.addEventListener("click", (event) => {
  const btn = event.target.closest(".see-my-size-btn");
  if (!btn) return;

  event.stopImmediatePropagation();
  const triggerElement = btn.closest('[data-trigger-seemysize]');
  if (!triggerElement) return;

  const type = triggerElement.getAttribute('data-trigger-seemysize');
  // Normalize type name to match the see-my-size-data IDs
  const normalizedType = type.toLowerCase()
    .replace('baller-luxe', 'baller')
    .replace('star-luxe', 'star')
    .replace('bikini-luxe', 'bikini')
    .replace('baller-rib', 'baller')
    .replace('biker-flex', 'biker')
    .replace('baller_padliner', 'baller')
    .replace('biker-padliner', 'biker')
    .replace('star-padliner', 'star')
    .replace('starluxe', 'star')
    .replace('bikiniluxe', 'bikini')
    .replace('baller high waisted', 'baller-high-waisted')
    .replace('biker high waisted', 'biker-high-waisted')
    .replace('star flex', 'star')
    .replace('baller flex', 'baller')
    .replace('ballerhighwaisted_pack', 'baller-high-waisted')
    .replace('bikerhighwaisted_pack', 'biker-high-waisted')
    .replace('ballerpadliner_pack', 'baller')
    .replace('bikerpadliner_pack', 'biker')
    .replace('starpadliner_pack', 'star')
    .replace('starluxe_pack', 'star')
    .replace('bikiniluxe_pack', 'bikini')
    .replace('starflex_pack', 'star')
    .replace('ballerflex_pack', 'baller')
    .replace('ballerwim_pack', 'baller')
    .replaceAll('_pack', '');

  const seeMySizeDataElement = document.querySelector(`[data-see-my-size="${normalizedType}"]`);
  const seeMySizeData = seeMySizeDataElement?.innerHTML.trim();

  if (seeMySizeData) {
    const seeMySizeModal = document.createElement("see-my-size");
    seeMySizeModal.dataset.seeMySizeData = seeMySizeData;

    // Check for selected size in both the trigger element and global state
    let container = btn.closest("[data-selected-product-size]");
    if (!container) {
      container = document.querySelector("[data-selected-product-size]");
    }

    if (container) {
      seeMySizeModal.dataset.selectedSize = container.getAttribute('data-selected-product-size').trim();
    }

    document.querySelector("body").prepend(seeMySizeModal);
    document.querySelector('body').classList.add('position-fixed-mobile');
    document.body.style.overflowY = "hidden";
    Utils.openOverlay();

    document.querySelector('[data-see-size-step-1]')?.classList?.remove('d-none');
    document.querySelector('[data-see-size-step-2]')?.classList?.add('d-none');
    document.querySelector('[data-see-size-mini-swatch]')?.classList?.add('d-none');
    document.querySelector('[data-see-size-mini-swatch]')?.classList?.remove('d-flex');
    document.querySelector('[data-see-size-back]')?.classList?.add('d-none');
  }
});

let newMaterial = document.querySelector('[data-enable-material="true"]')
if (newMaterial) {
  document.querySelectorAll('[data-new-material]').forEach((ele) => {
    ele.classList.remove('d-none');
    ele.classList.add('d-flex');
  })
  var htmlObject = {
    'standard': null,
    'highwaisted': null,
    'highsupport': null,
    'win_star': null,
    'win_baller': null,
    'baller': null,
    'baller-fluid-light': null,
    'star': null,
    'star-fluid-light': null,
  }
  var highwaisted = document.querySelector('[data-product-material-type]').getAttribute('data-product-material-type');
  let container = document.querySelector('[data-product-container]');
  if (container.querySelector('[data-support-bar]')) {
    container.querySelector('[data-support-bar] .container_block.active')?.classList?.remove('active');
    container.querySelector(`[data-support-bar] ${highwaisted != "highwaisted" ? '[data-light-container]' : '[data-medium-container]'}`)?.classList?.add('active');
  }
  htmlObject[`${highwaisted}`] = {
    product: document.querySelector('[data-product-material-type]').innerHTML,
    comfort: document.querySelector('.comfort-section')?.closest('.shopify-section')?.innerHTML
  };

  _fetchHighWaistedProduct();
  async function _fetchHighWaistedProduct() {

    let url = null;
    let url2 = null;
    if (highwaisted == "standard") {
      url = document.querySelector('[data-material_2_url]')?.getAttribute('data-material_2_url')
      url2 = document.querySelector('[data-material_3_url]')?.getAttribute('data-material_3_url')
    } else if (highwaisted == "highwaisted") {
      url = document.querySelector('[data-material_1_url]')?.getAttribute('data-material_1_url')
      url2 = document.querySelector('[data-material_3_url]')?.getAttribute('data-material_3_url')
    } else if (highwaisted == "win_star") {
      url = document.querySelector('[data-material_5_url]')?.getAttribute('data-material_5_url')
    } else if (highwaisted == "win_baller") {
      url = document.querySelector('[data-material_4_url]')?.getAttribute('data-material_4_url')
    } else if (highwaisted == "baller") {
      url = document.querySelector('[data-material_7_url]')?.getAttribute('data-material_7_url')
    } else if (highwaisted == "baller-fluid-light") {
      url = document.querySelector('[data-material_6_url]')?.getAttribute('data-material_6_url')
    } else if (highwaisted == "star") {
      url = document.querySelector('[data-material_7_url]')?.getAttribute('data-material_7_url')
    } else if (highwaisted == "star-fluid-light") {
      url = document.querySelector('[data-material_6_url]')?.getAttribute('data-material_6_url')
    } else {
      url = document.querySelector('[data-material_1_url]')?.getAttribute('data-material_1_url')
      url2 = document.querySelector('[data-material_2_url]')?.getAttribute('data-material_2_url')
    }
    let response = await fetch(url);
    let data = await response.text();
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(data, 'text/html');
    const materialEl = htmlDocument.querySelector('[data-product-material-type]');
    if (materialEl) {
      let isHighwaisted = materialEl.getAttribute('data-product-material-type');
      htmlObject[`${isHighwaisted}`] = {
        product: materialEl.innerHTML,
        comfort: htmlDocument.querySelector('.comfort-section')?.closest('.shopify-section')?.innerHTML
      };
    }

    if (url2) {
      let response2 = await fetch(url2);
      let data2 = await response2.text();
      const parser2 = new DOMParser();
      const htmlDocument2 = parser2.parseFromString(data2, 'text/html');
      const materialEl2 = htmlDocument2.querySelector('[data-product-material-type]');
      if (materialEl2) {
        let isHighwaisted2 = materialEl2.getAttribute('data-product-material-type');
        htmlObject[`${isHighwaisted2}`] = {
          product: materialEl2.innerHTML,
          comfort: htmlDocument2.querySelector('.comfort-section')?.closest('.shopify-section')?.innerHTML
        };
      }
    }
  }

  function _attachEvent() {
    document.querySelectorAll('[data-material]').forEach((ele) => {
      ele.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        let material = ele.getAttribute('data-material');
        let existingMaterial = document.querySelector('[data-material].active').getAttribute('data-material');

        htmlObject[existingMaterial] = {
          product: document.querySelector('[data-product-material-type]').innerHTML,
          comfort: document.querySelector('.comfort-section')?.closest('.shopify-section')?.innerHTML
        };
        let data = htmlObject[material];
        if (data && data.product) {
          let currentForm = document.querySelector('product-form:not(.d-none) [data-product-url].selected').closest('form');
          let selectedSize = currentForm.querySelector('[name="size"]:checked')?.value;
          let purchaseType = currentForm?.querySelector('[data-purchasetype].selected')?.getAttribute('data-purchasetype');
          // let type=currentForm.querySelector('[data-widget-container-wrapper] input:checked').closest('[data-purchasetype]').getAttribute('data-purchasetype')
          document.querySelector('[data-product-material-type]').innerHTML = data.product;

          if (data.comfort) {
            let comfortSection = document.querySelector('.comfort-section')?.closest('.shopify-section');
            if (comfortSection) {
              comfortSection.innerHTML = data.comfort;
            }
          }

          //support bar adjustment for boss and icon
          try {
            window.okeWidgetApi?.initAllWidgets();
            let container = document.querySelector('[data-product-container]');
            if (container.querySelector('[data-support-bar]')) {
              container.querySelector('[data-support-bar] .container_block.active')?.classList?.remove('active');
              if (material === 'standard') {
                container.querySelector(`[data-support-bar] [data-light-container]`)?.classList?.add('active');
              } else {
                container.querySelector(`[data-support-bar] [data-medium-container]`)?.classList?.add('active');
              }
            }

            let productDetailsPerks = document.querySelector('.pdp-perks-content');
            if (productDetailsPerks) {
              if (material === 'standard') {
                productDetailsPerks.classList?.add('d-none');
              } else {
                productDetailsPerks.classList?.remove('d-none');
              }
            }

          } catch (e) {
            console.log(e)
          }

          try {
            let url = ele.getAttribute('data-material_url');
            history.pushState(null, null, `${window.location.origin}${url}`);
          } catch (err) {
            console.error(err)
          }
          let newForm = document.querySelector('product-form:not(.d-none) [data-product-url].selected').closest('form');
          newForm.querySelector(`[name="size"][value="${selectedSize}"]`)?.click();

          if (purchaseType != undefined && purchaseType.length != 0 && currentForm.querySelectorAll(`[data-purchasetype]`).length > 1) {
            newForm.querySelector(`[data-purchasetype="${purchaseType}"] label`)?.click();
          }

          document.querySelectorAll('[data-new-material]').forEach((ele) => {
            ele.classList.remove('d-none');
            ele.classList.add('d-flex');
          })
          document.querySelectorAll('[data-modal-opener="new-size-guide-popup"]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
              event.stopImmediatePropagation();
              document.querySelector('#new-size-guide-popup')?.show();
              ele?.manageSizeGuide(ele);
            })
          })
          _attachEvent();
        }
        let currentForm = document.querySelector('product-form:not(.d-none)');
        currentForm.handlePdpImageSlider();
      })
    })
  }
  _attachEvent();
}

function _setPdpFaqInCustomBlock() {
  let faqContainer = document.querySelector('#pdp-style-wise-faq');
  if (faqContainer) {
    let productType = faqContainer.querySelector('[product-type]')?.getAttribute('product-type');
    let customContainer = document.querySelector('.pdp-faq-for-padliner');
    if ((productType === 'baller_padliner' || productType === 'ballerpadliner_pack' || productType === 'biker-padliner' || productType === 'bikerpadliner_pack' || productType === 'star-padliner' || productType === 'starpadliner_pack') && customContainer) {
      let section = faqContainer.closest('.shopify-section');
      customContainer.appendChild(faqContainer);
      if (section) {
        section.style.display = 'none';
      }
    }
  }
}
_setPdpFaqInCustomBlock();
Utils.formatFilterQuery = (filterStr) => {
  const replacements = {
    '"filters":': "filters:",
    '"variantOption"': "variantOption",
    '"name"': "name",
    '"value"': "value",
    "{filters": "filters",
    "]}": "]",
    '"namespace"': "namespace",
    '"key"': "key",
    '"productMetafield"': "productMetafield",
    '"price"': "price",
    '"min":"': "min:",
    '","max":"': ",max:",
    '0"': "0",
    '1"': "1",
    '2"': "2",
    '3"': "3",
    '4"': "4",
    '5"': "5",
    '6"': "6",
    '7"': "7",
    '8"': "8",
    '9"': "9",
    '10"': "10",
  };
  return Object.entries(replacements).reduce(
    (acc, [pattern, replacement]) => acc.replaceAll(pattern, replacement),
    filterStr
  );
};

Utils.setImageUrlWidth = (imageUrl, width) => {
  const newImageUrl = `${imageUrl}&width=${width}`;
  return newImageUrl;
};

Utils.formatMoney = (value) => {
  let cents = value * 100;
  let format = "${{amount}}";
  if (format == null || format == undefined) {
    format = window.globalVariables.money_format || "${{ amount }}";
  }
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value).replace(".00", "");
};

Utils.getOffPercentage = (compareAtPrice, price) => {
  const offPercentage =
    100 - (parseFloat(price) / parseFloat(compareAtPrice)) * 100;
  return Math.round(offPercentage);
};

Utils.formatProductId = (productId) => {
  return productId.replaceAll("gid://shopify/Product/", "");
};

Utils.formatVariantId = (variantId) => {
  return variantId.replaceAll("gid://shopify/ProductVariant/", "");
};

Utils.formatSellingPlanId = (sellingPlanId) => {
  return sellingPlanId.replaceAll("gid://shopify/SellingPlan/", "");
};

Utils.capitalizeStr = (str) => {
  const capitalizeWords = str.replace(/\b\w/g, (letter) =>
    letter.toUpperCase()
  );
  return capitalizeWords;
};

Utils.handleize = (str) => {
  return str
    .toLowerCase()
    .replace(/[^\w\s-]/g, "") // Remove non-word characters, spaces, and hyphens
    .replace(/[\s_-]+/g, "-") // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, ""); // Trim leading and trailing hyphens
};

Utils.isMobile = () => {
  const width = window.innerWidth;

  return width <= 769;
};

Utils.updateOfferTaglineCustom = () => {
  try {
    // Check if `window.currentProduct` and `window.currentProduct.product` exist
    if (!window.currentProduct || !window.currentProduct.product) {
      console.warn("window.currentProduct or window.currentProduct.product is not defined.");
      return; // Exit the function if the product data is not available
    }

    if (window.currentProduct.product.tags.includes('PACK')) {
      return;
    }

    // Attempt to select the current product wrapper element
    let currentProductWrapper = document.querySelector(`[data-product-container="${window.currentProduct.product.id}"]`);

    // Fallback to a generic `[data-product-container]` if the specific one is not found
    if (!currentProductWrapper) {
      currentProductWrapper = document.querySelector(`[data-product-container][data-single-product]`);
    }

    // Proceed if a product wrapper was found
    if (currentProductWrapper) {
      const singleCustomOfferTagline = currentProductWrapper.querySelector('.text-left .main-offer');

      // Check if the tagline element exists
      if (singleCustomOfferTagline) {
        // Ensure `currentVariant` exists; default to an empty object if not
        const variant = window.currentProduct.product.currentVariant || {};

        // Ensure `tags` array exists; default to an empty array if not
        const tags = window.currentProduct.product.tags || [];

        // Check if global variables are defined, and use default values if they are not
        const xsDiscountTag = window.globalVariables?.xs_discount_product_tag || '';
        const xsDiscountTagline = window.globalVariables?.xs_discount_tagline || '';

        // Set the tagline based on the variant option and tags
        if (variant.option1 === 'XS' && tags.includes(xsDiscountTag)) {
          singleCustomOfferTagline.innerHTML = `<strong>${xsDiscountTagline}</strong>`;
        } else {
          singleCustomOfferTagline.innerHTML = singleCustomOfferTagline.getAttribute('data-offer-tagline') || '';
        }
      } else {
        console.warn("singleCustomOfferTagline element not found.");
      }
    } else {
      console.warn("currentProductWrapper element not found.");
    }
  } catch (error) {
    console.error("Error in Utils.updateOfferTaglineCustom:", error);
  }
};

Utils.addVideoIcon = (swiperWrapper) => {
  swiperWrapper?.querySelectorAll(".swiper-slide").forEach((slide, index) => {
    const includesVideo = slide.querySelector("custom-video, video");
    if (includesVideo) {
      swiperWrapper
        .querySelectorAll(".swiper-pagination-bullet")
        .forEach((bullet, bulletIndex) => {
          if (index === bulletIndex) {
            bullet.classList.add("video-icon");
          }
        });
    }
  });
};

// Related products section
const relatedProductsWrapper = document.querySelectorAll(
  ".section-related-products"
);
relatedProductsWrapper.forEach(wrapper => {
  const relatedProdPrevBtn = wrapper?.querySelector(
    ".slider-nav-btn[data-prev-button]"
  );
  const relatedProdNextBtn = wrapper?.querySelector(
    ".slider-nav-btn[data-next-button]"
  );

  relatedProdPrevBtn?.addEventListener("click", () => {
    wrapper?.querySelector(".swiper-button-prev")?.click();
  });

  relatedProdNextBtn?.addEventListener("click", () => {
    wrapper?.querySelector(".swiper-button-next")?.click();
  });
})
// Same color products section

const sameColorProductsWrapper = document.querySelector(
  ".section-same-color-products"
);
const sameColorProdPrevBtn = sameColorProductsWrapper?.querySelector(
  ".slider-nav-btn[data-prev-button]"
);
const sameColorProdNextBtn = sameColorProductsWrapper?.querySelector(
  ".slider-nav-btn[data-next-button]"
);

sameColorProdPrevBtn?.addEventListener("click", () => {
  sameColorProductsWrapper?.querySelector(".swiper-button-prev")?.click();
});

sameColorProdNextBtn?.addEventListener("click", () => {
  sameColorProductsWrapper?.querySelector(".swiper-button-next")?.click();
});

// Collection products section
const collectionProductsWrapper = document.querySelector(
  ".collection-product-slider .section-related-products"
);
const collectionProdPrevBtn = collectionProductsWrapper?.querySelector(
  ".slider-nav-btn[data-prev-button]"
);
const collectionProdNextBtn = collectionProductsWrapper?.querySelector(
  ".slider-nav-btn[data-next-button]"
);

collectionProdPrevBtn?.addEventListener("click", () => {
  collectionProductsWrapper?.querySelector(".swiper-button-prev")?.click();
});

collectionProdNextBtn?.addEventListener("click", () => {
  collectionProductsWrapper?.querySelector(".swiper-button-next")?.click();
});

// Secondary reviews section
const secondaryReviewsWrapper = document.querySelector(
  ".secondary-product-reviews"
);
const prevBtn = secondaryReviewsWrapper?.querySelector(
  ".slider-nav-btn[data-prev-button]"
);
const nextBtn = secondaryReviewsWrapper?.querySelector(
  ".slider-nav-btn[data-next-button]"
);

prevBtn?.addEventListener("click", () => {
  secondaryReviewsWrapper.querySelector(".swiper-button-prev").click();
});

nextBtn?.addEventListener("click", () => {
  secondaryReviewsWrapper.querySelector(".swiper-button-next").click();
});

function addWeekdays(startDate, days) {
  const date = new Date(startDate);
  let added = 0;

  while (added < days) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay(); // 0=Sun, 6=Sat
    if (day !== 0 && day !== 6) {
      added++;
    }
  }

  return date;
}

function formatDate(date) {
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
}

// MAIN
try {
  const today = new Date();
  const startDate = addWeekdays(today, 5); // 5 weekdays from today
  const endDate = addWeekdays(today, 7);   // 7 weekdays from today

  if (document.querySelector('.estimated_delivery_container .estimated_date')) {
    document.querySelector('.estimated_delivery_container .estimated_date').textContent = `${formatDate(startDate)} - ${formatDate(endDate)}`;
  }
} catch (e) {
  console.log(e)
}

document.querySelectorAll(".variant-size .form-label").forEach((sizeSwatch) => {
  sizeSwatch.addEventListener("click", (event) => {
    let container = event.target.closest("[data-selected-product-size]");
    if (container) {
      container.setAttribute('data-selected-product-size', sizeSwatch.innerText);
    }

    let stickyContainer = container.querySelector("[data-sticky-atc]");
    if (stickyContainer) {
      stickyContainer.querySelector('.size-title').innerText = sizeSwatch.innerText.toString().replace(/(\r\n|\n|\r)/gm, "");
      stickyContainer.querySelector('.size-separator').classList.remove('d-none');
      stickyContainer.querySelector('.size-menu')?.classList.toggle('d-none');
    }
    document
      .querySelectorAll(".form-color-swatch-wrapper")
      .forEach((colorSwatch) => {
        if (!colorSwatch.dataset.variants) {
          console.log(colorSwatch);
        }
        const variants = JSON.parse(colorSwatch.dataset.variants);
        const matchedVariant = variants.find(
          (variant) =>
            variant.option1.toLowerCase() === sizeSwatch.innerText.toLowerCase()
        );
        if (matchedVariant && !matchedVariant.available) {
          colorSwatch.classList.add("sold-out");
        } else {
          colorSwatch.classList.remove("sold-out");
        }
      });
  });
});

document.querySelectorAll(".pdp-size-selector-ab [data-single_size]").forEach((ele) => {
  ele.addEventListener("click", (event) => {
    let container = event.target.closest("[data-selected-product-size]");
    let sizeValue = ele.closest('[data-single_size]')?.getAttribute('data-single_size')?.toLowerCase();
    container?.setAttribute('data-selected-product-size', sizeValue);

    let stickyContainer = container.querySelector("[data-sticky-atc]");
    if (stickyContainer) {
      stickyContainer.querySelector('.size-title').innerText = sizeValue?.toString()?.replace(/(\r\n|\n|\r)/gm, "");
      stickyContainer.querySelector('.size-separator').classList.remove('d-none');
      stickyContainer.querySelector('.size-menu')?.classList.toggle('d-none');
    }
    document
      .querySelectorAll(".form-color-swatch-wrapper")
      .forEach((colorSwatch) => {
        if (!colorSwatch.dataset.variants) {
          console.log(colorSwatch);
        }
        const variants = JSON.parse(colorSwatch.dataset.variants);
        const matchedVariant = variants.find(
          (variant) =>
            variant.option1.toLowerCase() === sizeValue.toLowerCase()
        );
        if (matchedVariant && !matchedVariant.available) {
          colorSwatch.classList.add("sold-out");
        } else {
          colorSwatch.classList.remove("sold-out");
        }
      });
  });
});

// Add play icon mobile slider
Utils.addVideoIcon(document.querySelector("[data-mobile-product-slider]"));

// Only reveal the gallery first-image badge once its product image has actually loaded
document.querySelectorAll('.gallery-first-image-badge').forEach((badge) => {
  const productImage = badge.previousElementSibling;
  if (!productImage || productImage.tagName !== 'IMG') return;

  const showBadge = () => badge.classList.remove('d-none');

  if (productImage.complete && productImage.naturalWidth > 0) {
    showBadge();
  } else {
    productImage.addEventListener('load', showBadge, { once: true });
    productImage.addEventListener('error', showBadge, { once: true });
  }
});

document.querySelector('.overlay')?.addEventListener('click', () => {
  Utils.closeOverlay();
  document.querySelectorAll('see-my-size, quick-buy, lightbox-modal').forEach(element => element.remove());
});

// Autoplay video on page load
document.addEventListener('DOMContentLoaded', () => {
  if (!Utils.isMobile()) {
    const videoWrapper = document.querySelector('.product-images-listing-wrapper .custom-video-container');
    videoWrapper?.querySelector('.play__button')?.click();
    const videoElement = videoWrapper?.querySelector('video');
    videoElement?.play();
  }

  document.querySelectorAll('[data-product-accordion] a[href="#size__chart"]').forEach(ele => {
    ele.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const type = document.querySelector('[data-modal-opener="new-size-guide-popup"]');

      document.querySelector('#new-size-guide-popup .modal')?.classList.add('open');
      if (type?.getAttribute('data-main-type') === 'bottom') {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.remove('open')
      } else if (type?.getAttribute('data-main-type') === 'top') {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.remove('open')
      } else if (type?.getAttribute('data-main-type') === 'swim-top') {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.remove('open')
      } else if (type?.getAttribute('data-main-type') === 'swim-bottom') {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.remove('open')
      } else {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.remove('open')
      }
    })
  })
});

class ProductTabGroup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initTabs();
  }

  initTabs() {
    const tabs = this.querySelectorAll(".tab");
    const productForm = this.closest('product-form');
    const savedTab = productForm ? (productForm.getAttribute('selected-color-tab') || '0') : '0';
    const activeTabIndex = parseInt(savedTab);

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");
        this.toggleColorSections(index);
      });

      if (index === activeTabIndex) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });

    if (tabs.length > 0) {
      this.toggleColorSections(activeTabIndex);
    }
  }

  toggleColorSections(activeTabIndex) {
    let productForm = this.closest('product-form');

    if (!productForm) return;
    switch (activeTabIndex) {
      case 0:
        console.log('clicked 0')
        productForm.setAttribute('selected-color-tab', 0)
        break;
      case 1:
        console.log('clicked 1')
        productForm.setAttribute('selected-color-tab', 1)
        break;
      case 2:
        console.log('clicked 2')
        productForm.setAttribute('selected-color-tab', 2)
        break;
      default:
        console.log('clicked default')
    }
  }
}

customElements.define("product-tab-group", ProductTabGroup);